<template>
  <v-container class="mb-10" fluid>
    <v-card>
      <section class="pa-2 d-flex align-center">
        <v-row align="center">
          <v-col cols="auto">
            <v-icon
              color="primary"
              @click="$router.replace('/main/manual-orders')"
              class="d-none d-sm-inline"
            >
              mdi-chevron-left-circle
            </v-icon>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-btn
              block
              @click="changeTab('tabs-1')"
              color="primary"
              :outlined="getOutlinedButton('tabs-1')"
              class="white--text font-weight-bold body-2"
              :disabled="$route.params.upload"
            >
              {{ $_strings.manualOrders.ORDER_TITLE}}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-btn
              :disabled="isEdit"
              block
              @click="changeTab('tabs-2')"
              color="primary"
              :outlined="getOutlinedButton('tabs-2')"
              class="font-weight-bold body-2"
            >
              {{ $_strings.manualOrders.REVIEW_ORDER}}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-btn
              block
              @click="showDialogOrderUploaded"
              color="info"
              class="font-weight-bold body-2 white-text"
            >
              {{ $_strings.manualOrders.STATUS_UPLOAD }}
            </v-btn>
          </v-col>
        </v-row>
      </section>

      <v-tabs-items v-model="tabs">
        <v-tab-item
          value="tabs-1"
        >
          <v-card flat>
            <CheckOrder
              ref="checkOrder"
              :form="form"
              :isBasp="!!$route.params.isBasp"
              :loaders="loaders"
              :errors="errors"
              :filters="filters"
              :allowFetch="allowFetch"
              :mouDetail="mouDetail"
              :minBackDate="minBackDate"
              @updateCategoryItems="updateCategoryItems"
              @getServiceType="getServiceType"
              @getTransportType="getTransportType"
              @getOrigin="getOrigin"
              @getDestination="getDestination"
              @getMultipick="getMultipick"
              @getMultidrop="getMultidrop"
              @getMultishipper="getMultishipper"
              @getRouteOriginBackhauling="getRouteOriginBackhauling"
              @resetValueData="resetValueData"
            />
            <h4
              class="pl-5"
              v-if="form.serviceType === 'FCL_BACKHAULING'
                && !$route.params.isBasp"
            >
              {{ $_strings.manualOrders.BACKHAULING_ORDER }}
            </h4>
            <Backhauling
              ref="backhauling"
              v-if="form.serviceType === 'FCL_BACKHAULING' && !$route.params.isBasp"
              :form="form"
              :loaders="loaders"
              :errors="errors"
              :filters="filters"
              @updateCategoryItems="updateCategoryItems"
              @getRouteOriginBackhauling="getRouteOriginBackhauling"
              @getDestination="getDestinationBackhauling"
              @getMultipick="getMultipickBackhauling"
              @getMultidrop="getMultidropBackhauling"
              @resetValueData="resetValueData"
            />
            <!-- BUTTONS ACTIONS -->

            <!-- BUTTON EDIT -->
            <v-row
              class="pa-2 justify-end"
              align="end"
              v-if="isEdit"
            >
              <v-col cols="auto" class="text-center">
                <v-btn
                  min-width="200"
                  color="primary"
                  outlined
                  @click="cancelUpdateOrder"
                  class="white--text font-weight-bold body-2">
                  {{ $_strings.common.CANCEL}}
                </v-btn>
              </v-col>
              <v-col cols="auto" class="text-end">
                <v-btn
                  depressed
                  color="primary"
                  min-width="200"
                  @click="updateOrder"
                >
                  {{ $_strings.manualOrders.UPDATE_ORDER }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row
              v-else
              class="pa-2 justify-end"
              align="end"
            >
              <v-col cols="12" sm="4" md="3" class="text-end">
                <v-btn
                  depressed
                  color="warning"
                  block
                  @click="addOrder"
                >
                  {{ $_strings.manualOrders.ADD_ORDER }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="text-end">
                <v-btn
                  depressed
                  class="white--text font-weight-bold"
                  color="secondary"
                  block
                  @click="duplicateOrder"
                >
                  {{ $_strings.manualOrders.DUPLICAT_ORDER }}
                </v-btn>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="text-center">
                <v-btn
                  depressed
                  color="primary"
                  block
                  @click="orderNow"
                >
                  {{ $_strings.manualOrders.SEND_ORDER }} ({{orders.length}})
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item
          value="tabs-2"
        >
          <v-card flat>
            <OverviewOrder
              :orders="orders"
              @setAddNewOrder="setAddNewOrder"
              @editOrder="setEditOrder"
              @createShipments="createShipments"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <DialogMessageOrder
      :messageDialog="messageDialog"
      ref="dialogMessageOrder"
    />
    <DialodOrderUploaded
      ref="dialogOrderUploaded"
    />
  </v-container>
</template>

<script>
import dayjs from 'dayjs';
import { getDateTimeTz, skipEmptyStringObject } from '@/helper/commonHelpers';
import CheckOrder from './CheckOrder';
import Backhauling from './Backhauling.vue';
import DialogMessageOrder from '../Dialog/MessageOrder.vue';
import OverviewOrder from './OverviewOrder';
import DialodOrderUploaded from '../Dialog/OrderUploaded.vue';

export default {
  name: 'create-manual-order',
  components: {
    CheckOrder,
    OverviewOrder,
    Backhauling,
    DialogMessageOrder,
    DialodOrderUploaded,
  },
  created() {
    const { orders } = this.$route.params;
    if (orders) {
      this.orders = orders.map((x) => ({
        ...this.form,
        ...x,
      }));
      this.changeTab('tabs-2');
    } else {
      this.fetchMouDetail();
      this.fetchClosePeriod();
    }
  },
  data() {
    return {
      tabs: 'tabs-1',
      valid: false,
      statusDatetimeTz: this.getDateTimeTz(),
      allowFetch: {
        isAllowFetchServiceType: false,
      },
      mouDetail: {},
      minBackDate: dayjs().format('YYYY-MM-DD'),
      form: {
        id: 0,
        pickupDate: null,
        isManualConfirmed: false,
        isManualStatusUpdated: false,
        serviceType: '',
        transportTypeId: 0,
        additionalNote: '',
        categoryId: 0,
        subCategoryId: 0,
        goodsNote: '',
        originLocationId: 0,
        originSenderName: '',
        originSenderPhone: '',
        originNote: '',
        destinationLocationId: 0,
        destinationReceiverName: '',
        destinationReceiverPhone: '',
        destinationNote: '',
        mouRoutesId: 0,
        shipmentsDetail: [],
        cubic: 0,
        tonase: 0,
        carton: 0,
        isShipperFullLoad: false,
        isShipperMergeShipment: false,
        reffShipperMergeShipmentId: 0,
        backhauling: null,
        isMultiShipper: false,
        // ITEMS
        items: {
          serviceType: [],
          itemsVehicle: [],
          itemsOrigin: [],
          itemsMultipick: [],
          itemsDestination: [],
          itemsMultidrop: [],
          itemsCategory: [],
          itemsSubCategory: [],
          itemsNoOrders: [],
          // ITEMS FOR BACKHAULING
          itemsOriginBackhauling: [],
          itemsMultipickBackhauling: [],
          itemsDestinationBackhauling: [],
          itemsMultidropBackhauling: [],
          itemsSubCategoryBackhauling: [],
        },

        // ROUTES
        routes: [],
        routesBackhauling: [],

        // TOOLS
        tools: {
          pickupDate: null,
          pickupTime: null,
        },
      },
      orders: [],
      messageDialog: '',

      indexOrderEdit: '',
      editOrder: {},
      isEdit: false,
      orderSuccess: false,
      getItemsOrderBasp: false,
      dialogBasp: false,
      errorMessage: '',
      // LOADERS
      loaders: {
        isLoadingGetCategory: false,
        isLoadingGetMoreCategory: false,
        isLoadingGetServiceType: false,
        isLoadingGetTransportType: false,
        isLoadingGetOrigin: false,
        isLoadingGetMoreOrigin: false,
        isLoadingGetDestination: false,
        isLoadingGetMoreDestination: false,
        isLoadingGetMultishipper: false,
        isLoadingGetOriginBackhauling: false,
      },
      // HANDLE ERROR
      errors: {
        isErrorGetCategory: false,
        isErrorGetServiceType: false,
        isErrorGetTransportType: false,
        isErrorGetOrigin: false,
        isErrorGetDestination: false,
        isErrorGetOriginBackhauling: false,
      },
      // FILTER
      filters: {
        originLocation: {
          page: 0,
          size: 250,
          transportTypeId: null,
          originName: '',
          totalData: 0,
        },
        destinationLocation: {
          page: 0,
          size: 250,
          transportTypeId: null,
          originId: null,
          totalData: 0,
          destinationName: '',
        },
        category: {
          page: 0,
          size: 50,
          totalData: 0,
          name: '',
        },
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!this.orderSuccess && to.name !== 'login') {
      // eslint-disable-next-line no-alert
      const r = window.confirm('Pesanan anda akan terhapus, apakah anda yakin?');
      if (r === true) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
  methods: {
    skipEmptyStringObject,
    getDateTimeTz,
    showDialogOrderUploaded() {
      this.$refs.dialogOrderUploaded.dialog = true;
    },
    setDefaultStateData() {
      let copyServiceType = this.form.serviceType;
      let copyTransportTypeId = this.form.transportTypeId;
      let copyItemsOrigin = [...this.form.items.itemsOrigin];
      if (this.form.items.serviceType.length > 1) {
        copyServiceType = '';
        copyTransportTypeId = 0;
        copyItemsOrigin = [];
      }
      if (this.form.items.itemsVehicle.length > 1) {
        copyTransportTypeId = 0;
        copyItemsOrigin = [];
      }
      this.form = {
        id: 0,
        isManualConfirmed: false,
        isManualStatusUpdated: false,
        pickupDate: null,
        serviceType: copyServiceType,
        transportTypeId: copyTransportTypeId,
        additionalNote: '',
        categoryId: 0,
        subCategoryId: 0,
        goodsNote: '',
        originLocationId: 0,
        originSenderName: '',
        originSenderPhone: '',
        originNote: '',
        destinationLocationId: 0,
        destinationReceiverName: '',
        destinationReceiverPhone: '',
        destinationNote: '',
        mouRoutesId: 0,
        shipmentsDetail: [],
        cubic: 0,
        tonase: 0,
        carton: 0,
        isShipperFullLoad: false,
        isShipperMergeShipment: false,
        reffShipperMergeShipmentId: 0,
        backhauling: null,
        isMultiShipper: false,
        // ITEMS
        items: {
          ...this.form.items,
          itemsOrigin: copyItemsOrigin,
          itemsMultipick: [],
          itemsDestination: [],
          itemsMultidrop: [],
          itemsSubCategory: [],
          itemsNoOrders: [],
          // ITEMS FOR BACKHAULING
          itemsOriginBackhauling: [],
          itemsMultipickBackhauling: [],
          itemsDestinationBackhauling: [],
          itemsMultidropBackhauling: [],
          itemsSubCategoryBackhauling: [],
        },

        // ROUTES
        routes: [],
        routesBackhauling: [],

        // TOOLS
        tools: {
          pickupDate: null,
          pickupTime: null,
        },
      };
    },
    resetValueData(resetBy) {
      const copyForm = { ...this.form };
      const copyFilter = { ...this.filters };
      switch (resetBy) {
        case 'fullResetForm':
          this.form.serviceType = '';
          this.form.isManualConfirmed = false;
          this.form.isManualStatusUpdated = false;
          this.resetValueData('pickupDate');
          break;
        case 'pickupDate':
          if (this.form.items.serviceType.length === 1) {
            this.form.serviceType = copyForm.serviceType;
          }
          this.form.transportTypeId = 0;
          this.form.originLocationId = '';
          this.form.destinationLocationId = '';
          this.form.destinationLocationProvinceId = '';
          this.form.cubic = 0;
          this.form.tonase = 0;
          this.form.carton = 0;
          this.form.mouRoutesId = 0;
          this.form.shipmentsDetail = [];
          this.form.items = {
            ...this.form.items,
            itemsVehicle: [],
            itemsOrigin: [],
            itemsMultipick: [],
            itemsDestination: [],
            itemsMultidrop: [],
            itemsNoOrders: [],
            // ITEMS FOR BACKHAULING
            itemsOriginBackhauling: [],
            itemsMultipickBackhauling: [],
            itemsDestinationBackhauling: [],
            itemsMultidropBackhauling: [],
          };
          if (this.form.serviceType === 'FCL_BACKHAULING') {
            this.form.backhauling = {
              additionalNote: '',
              categoryId: 0,
              subCategoryId: 0,
              goodsNote: '',
              originLocationId: 0,
              originSenderName: '',
              originSenderPhone: '',
              originNote: '',
              destinationLocationId: 0,
              destinationReceiverName: '',
              destinationReceiverPhone: '',
              destinationNote: '',
              mouRoutesId: 0,
              shipmentsDetail: [],
            };
          } else {
            this.form.backhauling = null;
          }
          this.form.routesBackhauling = [];
          // FILTERS
          this.filters = {
            ...this.filters,
            originLocation: {
              page: 0,
              size: 250,
              totalData: 0,
              transportTypeId: null,
              originName: '',
            },
            destinationLocation: {
              page: 0,
              size: 250,
              totalData: 0,
              originId: null,
              transportTypeId: null,
              destinationName: '',
            },
          };
          break;
        case 'serviceType':
          this.resetValueData('pickupDate');
          break;
        case 'vehicle':
          this.resetValueData('pickupDate');
          this.form.transportTypeId = copyForm.transportTypeId;
          this.form.items.itemsVehicle = copyForm.items.itemsVehicle;
          break;
        case 'locOrigin':
          this.resetValueData('pickupDate');
          // transporter
          this.form.transportTypeId = copyForm.transportTypeId;
          this.form.items.itemsVehicle = copyForm.items.itemsVehicle;
          // origin
          this.form.originLocationId = copyForm.originLocationId;
          this.form.items.itemsOrigin = copyForm.items.itemsOrigin;
          // filter
          this.filters.originLocation = copyFilter.originLocation;
          this.filters.destinationLocation = {
            page: 0,
            size: 250,
            totalData: 0,
            transportTypeId: null,
            originId: '',
            destinationName: '',
          };
          break;
        case 'locDest':
          this.resetValueData('pickupDate');
          this.form.transportTypeId = copyForm.transportTypeId;
          this.form.items.itemsVehicle = copyForm.items.itemsVehicle;
          // origin
          this.form.originLocationId = copyForm.originLocationId;
          this.form.items.itemsOrigin = copyForm.items.itemsOrigin;
          // destination
          this.form.destinationLocationId = copyForm.destinationLocationId;
          this.form.items.itemsDestination = copyForm.items.itemsDestination;
          // mou routes id
          this.form.mouRoutesId = copyForm.mouRoutesId;
          // filter
          this.filters.originLocation = copyFilter.originLocation;
          this.filters.destinationLocation = copyFilter.destinationLocation;
          break;
        case 'locOriginBackhauling':
          this.form.backhauling.destinationLocationId = '';
          this.form.backhauling.shipmentsDetail = [];

          this.form.items.itemsMultipickBackhauling = [];
          this.form.items.itemsMultidropBackhauling = [];
          break;
        default:
          break;
      }
    },
    async fetchClosePeriod() {
      const filters = {
        page: 0,
        size: 1,
        sort: 'isActive,DESC',
      };
      const result = await this.$_services.closePeriod.closePeriodList(this.skipEmptyStringObject(filters));
      if (result.data.contents.length) {
        const { periodName } = result.data.contents[0];
        const _periodName = `01-${periodName}`;
        const date = '01';
        let year = dayjs().format('YYYY');
        const splitYear = periodName.match(/\d+/g);
        if (splitYear) {
          year = `${year.slice(0, 2)}${splitYear[0]}`;
          const month = dayjs(_periodName).format('MM');
          this.minBackDate = `${year}-${month}-${date}`;
        }
      }
    },
    async fetchMouDetail() {
      const { mouId } = this.$route.query;
      this.$root.$loading.show();
      try {
        const result = await this.$_services.mou.fetchDetailMouShipper(mouId);
        this.mouDetail = result.data;
        this.form.isMultiShipper = result.data.isMultiShipper;
      } finally {
        this.$root.$loading.hide();
      }
    },
    updateCategoryItems(items) {
      this.form.items.itemsCategory = [...this.form.items.itemsCategory, ...items];
    },
    getServiceType() {
      const { companyId } = this.mouDetail;
      const { pickupDate } = this.form;
      this.loaders.isLoadingGetServiceType = true;
      this.errors.isErrorGetServiceType = false;
      const filter = {
        pickupDate,
      };
      this.$_services.manualOrders.getServiceType(companyId, skipEmptyStringObject(filter))
        .then((res) => {
          const serviceTypeData = [];
          res.data.forEach((type) => {
            const label = this.getLabelServiceType(type);
            serviceTypeData.push({
              label,
              value: type,
            });
          });
          if (serviceTypeData.length === 1) {
            this.form.serviceType = serviceTypeData[0].value;
            this.getTransportType();
            this.getOrigin();
          }
          this.form.items.serviceType = serviceTypeData;
        }).catch(() => {
          this.errors.isErrorGetServiceType = true;
        }).finally(() => {
          this.loaders.isLoadingGetServiceType = false;
        });
    },
    getTransportType() {
      const { companyId } = this.mouDetail;
      const { serviceType, pickupDate } = this.form;
      if (serviceType !== 'LCL') {
        this.loaders.isLoadingGetTransportType = true;
        this.errors.isErrorGetTransportType = false;
        const filter = {
          pickupDate,
        };
        this.$_services.manualOrders.getTransportType(companyId, serviceType, skipEmptyStringObject(filter))
          .then((res) => {
            const { data } = res;
            this.form.items.itemsVehicle = data;
            if (data.length === 1) {
              this.form.transportTypeId = data[0].transportTypeId;
              this.getOrigin();
            }
          }).catch(() => {
            this.errors.isErrorGetTransportType = true;
          }).finally(() => {
            this.loaders.isLoadingGetTransportType = false;
          });
      }
    },
    getOrigin(isLoading = 'isLoadingGetOrigin') {
      const { mouId } = this.$route.query;
      const { serviceType, transportTypeId } = this.form;
      const locOrigin = [];
      const { totalData } = this.filters.originLocation;
      const { itemsOrigin } = this.form.items;
      if (((serviceType && transportTypeId)
        || (serviceType === 'LCL'))
        && (totalData === 0 || itemsOrigin.length < totalData)
      ) {
        if (isLoading) this.loaders[isLoading] = true;
        this.errors.isErrorGetOrigin = false;
        this.filters.originLocation.transportTypeId = transportTypeId;
        const { page, size } = this.filters.originLocation;
        const filter = {
          page,
          size,
          transportTypeId,
        };
        return new Promise((resolve, reject) => {
          this.$_services.manualOrders.getOriginLocation(filter, { mouId, serviceType })
            .then((routes) => {
              if (routes.data) {
                routes.data.contents.forEach((route) => {
                  locOrigin.push({
                    ...route,
                    id: route.id,
                    text: route.originLocationName,
                    value: route.originLocationId,
                    originLocationCityId: route.originLocationCityId,
                    originLocationCityName: route.originLocationCityName,
                    originLocationAddress: route.originLocationAddress,
                  });
                });
              }
              this.filters.originLocation.page = routes.data.page;
              if (!this.filters.originLocation.totalData) this.filters.originLocation.totalData = routes.data.totalData;
              this.form.items.itemsOrigin = [
                ...this.form.items.itemsOrigin,
                ...locOrigin,
              ];
              resolve(routes);
            }).catch((error) => {
              this.errors.isErrorGetOrigin = true;
              reject(error);
            }).finally(() => {
              if (isLoading) this.loaders[isLoading] = false;
            });
        });
      }
    },
    getDestination(isLoading = 'isLoadingGetDestination') {
      const { companyId } = this.mouDetail;
      const {
        serviceType, transportTypeId, originLocationId, pickupDate,
      } = this.form;
      const destinationLoc = [];
      const { totalData } = this.filters.destinationLocation;
      const { itemsDestination, itemsOrigin } = this.form.items;
      if (totalData === 0 || itemsDestination.length < totalData) {
        if (isLoading) this.loaders[isLoading] = true;
        this.errors.isErrorGetDestination = false;
        this.filters.destinationLocation.transportTypeId = transportTypeId;
        this.filters.destinationLocation.originId = originLocationId;
        let mouId = null;
        if (itemsOrigin.find((x) => x.mouId)) {
          mouId = itemsOrigin.find((x) => x.mouId).mouId;
        }
        const { page, size } = this.filters.destinationLocation;
        const filter = {
          page,
          size,
          transportTypeId,
          pickupDate,
          originId: originLocationId,
        };
        this.$_services.manualOrders.getRoute(companyId, serviceType, skipEmptyStringObject(filter))
          .then((routes) => {
            if (routes.data) {
              routes.data.contents.forEach((route) => {
                destinationLoc.push({
                  ...route,
                  id: route.id,
                  text: route.destinationLocationName,
                  value: route.destinationLocationId,
                  destinationLocationId: route.destinationLocationId,
                  destinationLocationCityId: route.destinationLocationCityId,
                  destinationLocationCityName: route.destinationLocationCityName,
                  destinationLocationAddress: route.destinationLocationAddress,
                  destinationLocationProvinceId: route.destinationLocationProvinceId,
                });
              });
            }
            this.form.items.itemsDestination = [
              ...this.form.items.itemsDestination,
              ...destinationLoc,
            ];
            this.filters.destinationLocation.page = routes.data.page;
            if (!this.filters.destinationLocation.totalData) this.filters.destinationLocation.totalData = routes.data.totalData;
          }).catch(() => {
            this.errors.isErrorGetDestination = true;
          }).finally(() => {
            if (isLoading) this.loaders[isLoading] = false;
          });
      }
    },
    getMultipick() {
      const { destinationLocationId, originLocationId, items: { itemsDestination } } = this.form;
      const findRoute = itemsDestination.find((route) => (route.destinationLocationId === destinationLocationId && route.originLocationId === originLocationId));
      const multipick = [];
      if (findRoute.mouRoutesMultiLoc) {
        findRoute.mouRoutesMultiLoc.forEach((pick) => {
          if (pick.pickDrop.includes('PICK')) {
            multipick.push({
              id: pick.id,
              text: pick.locationName,
              value: pick.locationId,
              locationCityName: pick.locationCityName,
              locationName: pick.locationName,
              locationProvinceId: pick.locationProvinceId,
              mouRoutesId: pick.mouRoutesId,
            });
          }
        });
        this.form.items.itemsMultipick = multipick;
      }
    },
    getMultidrop() {
      const { destinationLocationId, originLocationId, items: { itemsDestination } } = this.form;
      const findRoute = itemsDestination.find((route) => (route.destinationLocationId === destinationLocationId && route.originLocationId === originLocationId));
      const multidrop = [];
      if (findRoute.mouRoutesMultiLoc) {
        findRoute.mouRoutesMultiLoc.forEach((drop) => {
          if (drop.pickDrop.includes('DROP')) {
            multidrop.push({
              id: drop.id,
              text: drop.locationName,
              value: drop.locationId,
              locationCityName: drop.locationCityName,
              locationName: drop.locationName,
              locationProvinceId: drop.locationProvinceId,
              mouRoutesId: drop.mouRoutesId,
            });
          }
        });
        this.form.items.itemsMultidrop = multidrop;
      }
    },
    getLabelServiceType(type) {
      switch (type) {
        case 'FCL':
          return 'Full Container Load';
        case 'FCL_BACKHAULING':
          return 'Full Container Load + Backhauling';
        case 'FCL+BACKHAULING':
          return 'Full Container Load + Backhauling';
        case 'LCL':
          return 'Less than Container Load';
        default:
          break;
      }
    },
    getMultishipper() {
      this.errors.isErrorGetMultishipper = false;
      const { pickupDate } = this.form.tools;
      const { isMultiShipper } = this.mouDetail;
      const {
        originLocationId,
        destinationLocationId,
        transportTypeId,
        serviceType,
      } = this.form;
      if (serviceType === 'LCL' && pickupDate && isMultiShipper && originLocationId && destinationLocationId) {
        this.loaders.isLoadingGetMultishipper = true;
        const filter = {
          originId: originLocationId,
          destId: destinationLocationId,
          transTypeId: transportTypeId,
          pickupDate,
        };
        this.$_services.manualOrders.getMultishipper(filter)
          .then((res) => {
            const noOrders = [];
            if (res.data) {
              res.data.forEach((multishipper) => {
                noOrders.push({
                  text: multishipper.title,
                  value: multishipper.id,
                });
              });
            }
            this.form.items.itemsNoOrders = noOrders;
          }).catch(() => {
            this.errors.isErrorGetMultishipper = true;
          }).finally(() => {
            this.loaders.isLoadingGetMultishipper = false;
          });
      }
    },
    // Backhauling
    getRouteOriginBackhauling() {
      const { companyId } = this.mouDetail;
      const {
        serviceType,
        destinationLocationId,
        mouRoutesId,
        pickupDate,
      } = this.form;
      const locOriginBackhauling = [];
      if ((destinationLocationId) && ((serviceType === 'FCL+BACKHAULING') || (serviceType === 'FCL_BACKHAULING'))) {
        this.loaders.isLoadingGetOriginBackhauling = true;
        this.errors.isErrorGetOriginBackhauling = false;
        const filter = {
          pickupDate,
        };
        this.$_services.manualOrders.getRouteBackhauling(companyId, mouRoutesId, skipEmptyStringObject(filter))
          .then((routesBackhauling) => {
            if (routesBackhauling.data) {
              routesBackhauling.data.forEach((route) => {
                locOriginBackhauling.push({
                  id: route.id,
                  text: route.originLocationName,
                  value: route.originLocationId,
                  originLocationCityId: route.originLocationCityId,
                  originLocationCityName: route.originLocationCityName,
                  originLocationAddress: route.originLocationAddress,
                });
              });
              this.form.routesBackhauling = routesBackhauling.data;
            }
            if (!locOriginBackhauling.length) this.$dialog.notify.error('Lokasi Backhauling Tidak ditemukan');
            this.form.items.itemsOriginBackhauling = locOriginBackhauling;
          }).catch(() => {
            this.errors.isErrorGetOriginBackhauling = true;
          }).finally(() => {
            this.loaders.isLoadingGetOriginBackhauling = false;
          });
      } else {
        this.form.items.itemsOriginBackhauling = locOriginBackhauling;
      }
    },
    getDestinationBackhauling() {
      const { backhauling } = this.form;
      const { serviceType } = this.form;
      const originLocationId = backhauling ? backhauling.originLocationId : null;
      const locDestBackhauling = [];
      if ((originLocationId) && ((serviceType === 'FCL+BACKHAULING') || (serviceType === 'FCL_BACKHAULING'))) {
        this.form.routesBackhauling.forEach((route) => {
          if (route.originLocationId === originLocationId) {
            locDestBackhauling.push({
              id: route.id,
              text: route.destinationLocationName,
              value: route.destinationLocationId,
              destinationLocationCityId: route.destinationLocationCityId,
              destinationLocationCityName: route.destinationLocationCityName,
              destinationLocationAddress: route.destinationLocationAddress,
              destinationLocationProvinceId: route.destinationLocationProvinceId,
              mouRoutesId: route.mouId,
            });
          }
        });
        this.form.items.itemsDestinationBackhauling = locDestBackhauling;
      } else {
        this.form.items.itemsDestinationBackhauling = locDestBackhauling;
      }
    },
    getMultipickBackhauling() {
      const { destinationLocationId, originLocationId } = this.form.backhauling;
      const routes = this.form.routesBackhauling.filter((route) => (route.destinationLocationId === destinationLocationId && route.originLocationId === originLocationId))[0];
      const multipick = [];
      if (destinationLocationId && routes.mouRoutesMultiLoc) {
        routes.mouRoutesMultiLoc.forEach((pick) => {
          if (pick.pickDrop.includes('PICK')) {
            multipick.push({
              id: pick.id,
              text: pick.locationName,
              value: pick.locationId,
              locationCityName: pick.locationCityName,
              locationName: pick.locationName,
              locationProvinceId: pick.locationProvinceId,
              mouRoutesId: pick.mouRoutesId,
            });
          }
        });
        this.form.items.itemsMultipickBackhauling = multipick;
      }
    },
    getMultidropBackhauling() {
      const { destinationLocationId, originLocationId } = this.form.backhauling;
      const routes = this.form.routesBackhauling.filter((route) => (route.destinationLocationId === destinationLocationId && route.originLocationId === originLocationId))[0];
      const multidrop = [];
      if (destinationLocationId && routes.mouRoutesMultiLoc) {
        routes.mouRoutesMultiLoc.forEach((pick) => {
          if (pick.pickDrop === 'DROP') {
            multidrop.push({
              id: pick.id,
              text: pick.locationName,
              value: pick.locationId,
              locationCityName: pick.locationCityName,
              locationName: pick.locationName,
              locationProvinceId: pick.locationProvinceId,
              mouRoutesId: pick.mouRoutesId,
            });
          }
        });
        this.form.items.itemsMultidropBackhauling = multidrop;
      }
    },
    // End Backhauling
    validate() {
      this.$refs.checkOrder.validateForm();
      const { isValidForm } = this.$refs.checkOrder;
      const { isBasp } = this.$route.params;

      let isValidFormBackhauling = true;
      if (this.form.serviceType === 'FCL_BACKHAULING' && !isBasp) {
        this.$refs.backhauling.validateForm();
        isValidFormBackhauling = this.$refs.backhauling.isValidForm;
      }
      if (!isValidForm) {
        this.$nextTick(() => {
          const el = this.$refs.checkOrder.$el.querySelector('.v-messages.error--text:first-of-type');
          this.$vuetify.goTo(el, { offset: 50 });
        });
      }
      if (!isValidFormBackhauling && isValidForm) {
        this.$nextTick(() => {
          const el = this.$refs.backhauling.$el.querySelector('.v-messages.error--text:first-of-type');
          this.$vuetify.goTo(el, { offset: 50 });
        });
      }
      return isValidForm && isValidFormBackhauling;
    },
    resetForm() {
      this.$refs.checkOrder.resetForm();
      if (this.form.serviceType === 'FCL_BACKHAULING') {
        this.$refs.backhauling.resetForm();
      }
    },
    addOrder() {
      if (!this.validate()) {
        return this.$dialog.notify.error('Periksa kembali field yang belum diisi!!');
      }
      this.messageDialog = 'Pesanan Berhasil Ditambahkan';
      this.$refs.dialogMessageOrder.dialog = true;
      const order = JSON.parse(JSON.stringify(this.form));
      this.orders.push(order);
      this.resetForm();
      this.setDefaultStateData();
    },
    setEditOrder(index) {
      const form = JSON.parse(JSON.stringify(this.orders[index]));
      this.form = form;
      this.isEdit = true;
      this.allowFetch.isAllowFetchServiceType = false;
      this.indexOrderEdit = index;
      this.tabs = 'tabs-1';
    },
    updateOrder() {
      if (!this.validate()) {
        return this.$dialog.notify.error('Periksa kembali field yang belum diisi!!');
      }
      this.messageDialog = 'Pesanan Berhasil Diupdate';
      this.$refs.dialogMessageOrder.dialog = true;
      const order = JSON.parse(JSON.stringify(this.form));
      this.orders.splice(this.indexOrderEdit, 1, order);
      this.isEdit = false;
      this.resetForm();
      this.setDefaultStateData();
      this.tabs = 'tabs-2';
    },
    cancelUpdateOrder() {
      this.isEdit = false;
      this.resetForm();
      this.setDefaultStateData();
      this.tabs = 'tabs-2';
    },
    duplicateOrder() {
      if (!this.validate()) {
        return this.$dialog.notify.error('Periksa kembali field yang belum diisi!!');
      }
      this.messageDialog = 'Pesanan Berhasil Diduplikasi';
      this.$refs.dialogMessageOrder.dialog = true;
      const order = JSON.parse(JSON.stringify(this.form));
      this.orders.push(order);
    },
    orderNow() {
      if (!this.validate()) {
        return this.$dialog.notify.error('Periksa kembali field yang belum diisi!!');
      }
      const order = JSON.parse(JSON.stringify(this.form));
      this.orders.push(order);
      this.resetForm();
      this.setDefaultStateData();
      this.tabs = 'tabs-2';
    },
    setAddNewOrder() {
      this.resetForm();
      this.setDefaultStateData();
      this.tabs = 'tabs-1';
    },
    refactorForm() {
      const orderShipments = JSON.parse(JSON.stringify(this.orders));
      orderShipments.forEach((order, index) => {
        delete orderShipments[index].items;
        delete orderShipments[index].routes;
        delete orderShipments[index].routesBackhauling;
        delete orderShipments[index].tools;
      });
      return orderShipments;
    },
    async uploadCsv() {
      try {
        const { formData } = this.$route.params;
        this.$root.$loading.show();
        await this.$_services.order.UploadShipmentShipperCSV({ formData });
        this.$dialog.notify.success('Berhasil mengunggah');
        this.orders = [];
      } finally {
        this.$root.$loading.hide();
      }
    },
    async createShipments() {
      const { upload } = this.$route.params;
      if (upload) return this.uploadCsv();
      const { shipperId } = this.$route.query;
      const service = this.$_services.manualOrders.createShipments;
      const shipments = this.refactorForm();
      try {
        this.$root.$loading.show();
        await service(shipperId, this.statusDatetimeTz, shipments);
        this.orderSuccess = true;
        this.$router.push('/main/update-orders');
        this.$dialog.notify.success('Berhasil mengirim pesanan');
      } finally {
        this.$root.$loading.hide();
      }
    },
    getOutlinedButton(tab) {
      if (this.tabs !== tab) {
        return true;
      }
    },
    changeTab(tab) {
      this.tabs = tab;
    },
  },
};
</script>

<style scoped lang="scss">
  .v-card {
    margin: 0;
  }
  nav {
    position: relative;
    overflow: scroll;
  }
</style>
